import { faImage } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';

export const NoHistoricalXrayPlaceholder = () => {
  return (
    <div className="vai-w-full vai-h-full vai-p-8 vai-flex vai-items-center vai-justify-center vai-border-2 vai-border-[#71717A] vai-border-solid vai-rounded-lg vai-max-h-[calc(100vh-300px)]">
      <div className="vai-flex vai-flex-col vai-items-center vai-gap-4 vai-text-center vai-px-8">
        <div className="vai-relative">
          <FontAwesomeIcon
            icon={faImage}
            className="vai-text-muted-foreground vai-text-6xl"
          />
        </div>
        <div className="vai-flex vai-flex-col vai-gap-2">
          <h3 className="vai-text-lg vai-font-semibold vai-text-zinc-200">
            <Trans>No historical x-ray available</Trans>
          </h3>
          <p className="vai-text-sm vai-text-zinc-200 vai-max-w-md">
            <Trans>
              We couldn&apos;t find a previous x-ray to compare with this visit.
              Once an earlier image is uploaded, comparisons will appear here
              automatically.
            </Trans>
          </p>
        </div>
      </div>
    </div>
  );
};
